import { IMAGES } from 'common/images';
import { Image } from 'react-bootstrap';
import LazyLoad from 'react-lazyload';
import 'components/Testimonials/index.scss';

export const TestimonialCard = ({ designation, apple, name, testimony, image }) => (
  <div className="testimonial-card">
    <div
      style={{ display: 'flex', justifyContent: 'space-between' }}
      className="justify-content-between testimonial-card__header"
    >
      <LazyLoad height={200} offset={100} once>
        <Image src={IMAGES.Stars} alt="rating-stars" className="testimonial-card__header__stars" />
      </LazyLoad>
      <Image
        src={apple ? IMAGES.Apple : IMAGES.Play}
        alt={apple ? 'App Store' : 'Play Store'}
        className="testimonial-card__header__store-img"
      />
    </div>
    <div className="testimonial-card__content">
      <div className="testimonial-card__profile__image-container">
        <LazyLoad height={200} offset={100} once>
          <Image
            className="rounded-circle testimonial-card__profile__image"
            alt="image of reviewer"
            src={image}
          />
        </LazyLoad>
      </div>
      <div className="testimonial-card__text-container">
        <p className="testimonial-card__profile__testimony">{testimony}</p>
        <p className="testimonial-card__profile__designation">
          {name} &nbsp;<span>{designation}</span>
        </p>
      </div>
    </div>
  </div>
);
